import React, { useState } from 'react';
import {
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useSubmit from 'hooks/useSubmit';
import DocsRequestTemplatesService from 'services/api/DocsRequestTemplates';
import SuccessMessage from '../SuccessMessage';

type DeleteDocRequestTemplateModalProps = {
  dataId: number
  onClose: () => void,
  reloadData: () => void,
};

function DeleteDocRequestTemplateModal( {
  dataId, onClose, reloadData,
}: DeleteDocRequestTemplateModalProps ) {
  const { t } = useTranslation();
  const [formSubmitted, setFormSubmitted] = useState( false );
  const [formSubmittedError, setFormSubmittedError] = useState<string>();

  const deleteItem = useSubmit( {
    promise: () => DocsRequestTemplatesService.deleteTemplate( dataId ),
    callbackError: ( errors ) => {
      setFormSubmitted( true );
      setFormSubmittedError( errors );
    },
    callback: ( ) => {
      setFormSubmitted( true );
      setFormSubmittedError( undefined );
      reloadData();
    },
    showAlert: false,
    deps: [dataId],
  } );

  return (
    <Modal
      show
      centered
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4">{ t( 'admin.doctemplate.delete' )}</h3>
            {formSubmitted
              ? (
                <SuccessMessage
                  description={formSubmittedError || t( 'admin.doctemplate.deleteSuccess' )}
                  onClose={onClose}
                  success={!formSubmittedError}
                />
              )
              : (
                <div className="text-center">
                  <p className="text--sm">
                    {t( 'admin.doctemplate.deleteMsg' )}
                  </p>

                  <Row>
                    <Col className="m-auto mt-3">
                      <Button
                        variant="danger"
                        className="btn--full-width"
                        onClick={deleteItem}
                      >
                        {t( 'admin.common.delete' )}
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteDocRequestTemplateModal;
